// extracted by mini-css-extract-plugin
var _1 = "EntityProfileTabUpdates-modulecontainer__WeKfM";
export { _1 as "container" }
